module.exports = __webpack_public_path__ + "img/coors-light-landing-gal-3.b087e7dd.jpg";